import { Button, Card } from 'react-bootstrap';
import { useAuth } from '../context/AuthContext';

export default function Profile() {
  const { user, logout } = useAuth();

  return (
    <Card className="mt-5 mx-auto" style={{ maxWidth: '400px' }}>
      <Card.Body>
        <h2 className="text-center mb-4">Profile</h2>
        {user && (
          <>
            <p><strong>Email:</strong> {user.email}</p>
            <p><strong>Display Name:</strong> {user.profile?.displayName}</p>
            <p><strong>Business Name:</strong> {user.profile?.businessName}</p>
            <Button 
              variant="danger" 
              onClick={logout}
              className="w-100 mt-3"
            >
              Logout
            </Button>
          </>
        )}
      </Card.Body>
    </Card>
  );
}